var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsiWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.6306V21.8024C29 26.7576 27.843 28 23.228 28H8.772C4.157 28 3 26.7576 3 21.8024V10.1976C3 5.24235 4.157 4 8.772 4H17.95",
    stroke: "#171719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.0013L25 9.0013L30.3333 3.66797",
    stroke: "#171719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H25",
    stroke: "#171719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21H25",
    stroke: "#171719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 14.7251C13.6661 14.7251 14.7466 13.6446 14.7466 12.3118C14.7466 10.9789 13.6661 9.89844 12.3333 9.89844C11.0004 9.89844 9.91992 10.9789 9.91992 12.3118C9.91992 13.6446 11.0004 14.7251 12.3333 14.7251Z",
    stroke: "#171719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9993 21.4423C16.8127 19.509 15.2793 17.989 13.346 17.8156C12.6793 17.749 11.9993 17.749 11.3193 17.8156C9.38602 18.0023 7.85268 19.509 7.66602 21.4423",
    stroke: "#171719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsiWallet);
export default __webpack_public_path__ + "static/media/ssi-wallet.ccf9bab7.svg";
export { ForwardRef as ReactComponent };